module.exports = __webpack_public_path__ + "static/media/cload-center.b2cd8875.png";